// Typography configuration
export const typography = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  h1: {
    fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" },
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  h2: {
    fontSize: { xs: "1.25rem", sm: "1.375rem", md: "1.5rem" },
    fontWeight: 700,
    lineHeight: 1.3,
    letterSpacing: "-0.01em",
  },
  h3: {
    fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h4: {
    fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h5: {
    fontSize: { xs: "0.625rem", sm: "0.6875rem", md: "0.75rem" },
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h6: {
    fontSize: { xs: "0.5rem", sm: "0.5625rem", md: "0.625rem" },
    fontWeight: 600,
    lineHeight: 1.4,
  },
  subtitle1: {
    fontSize: { xs: "0.4375rem", md: "0.5rem" },
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: { xs: "0.3125rem", md: "0.375rem" },
    fontWeight: 500,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: { xs: "0.4375rem", md: "0.5rem" },
    fontWeight: 400,
    lineHeight: 1.6,
  },
  body2: {
    fontSize: { xs: "0.3125rem", md: "0.375rem" },
    fontWeight: 400,
    lineHeight: 1.6,
  },
  button: {
    fontSize: { xs: "0.3125rem", md: "0.375rem" },
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: "0.025em",
  },
  caption: {
    fontSize: { xs: "0.1875rem", md: "0.25rem" },
    fontWeight: 400,
    lineHeight: 1.5,
  },
  overline: {
    fontSize: { xs: "0.6875rem", md: "0.75rem" },
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },
};

export default typography;
